/* eslint-disable */
;(function () {
    const d3 = require('d3')
    const _ = require('underscore')

    const dataTypeMap = {
        ba: 'Batting Avg',
        iso: 'Isolated Power',
        slg: 'SLG %',
        babip: 'BABIP',
        pitches: 'Pitch Breakdown',
        hits: 'Base Hits Breakdown',
        hr: 'Home Run Breakdown',
        k: 'Strikeouts',
        baa: 'Batting Avg Against',
        pitch_percent: 'Pitch %',
        velocity: 'Pitch Velocity',
        spin_rate: 'Spin Rate',
        launch_speed: 'Exit Velocity',
        exit_velocity: 'Exit Velocity',
        exit_velocity_against: 'Exit Velocity Against',
        effective_speed: 'Perceived Velocity',
    }

    const colorScaleTypes = {
        customOrange: 'custom-orange',
        originalSavantColorScale: 'original-savant',
        threePointSavantColorScale: 'three-point-savant',
        blueWhiteRed: 'blue-white-red',
        blueBlackRed: 'blue-black-red',
        blueGrayRed: 'blue-gray-red',
        blueWhiteRedConstantSB: 'blue-white-red-constant-SB',
        blueWhiteRedConstantSB2: 'blue-white-red-constant-SB-2',
        blueWMagentaRedConstantSB: 'blue-magenta-red-constant-SB',
    }

    function toColorScale(colorScaleType, dataType, data, customHighlight = null) {
        const d3 = require('d3')
        const extent = {
            ba: [0, 0.5],
            baa: [0, 0.25],
            iso: [0, 0.25],
            slg: [0, 1],
            babip: [0, 0.6],
            pitches: [0, data[0].total_pitches / 5],
            hits: [0, data[0].total_pitches / 5],
            hr: [0, data[0].total_pitches / 5],
            k: [0, data[0].total_pitches / 5],
            pitch_percent: [0, 20],
            velocity: [70, 100],
            spin_rate: [1500, 3000],
            launch_speed: [80, 105],
            exit_velocity: [80, 105],
            exit_velocity_against: [80, 105],
            effective_speed: [65, 100],
            zScore: [-3, 3],
        }
        const domain = customHighlight ? toDomain(customHighlight, true) : toDomain(extent[dataType])
        let range

        function toDomain(extent, triColor = false) {
            if (triColor) {
                return [extent[0], extent[1], extent[2]]
            }

            extent = extent || [0, 1]

            const start = extent[0]
            const stop = extent[1]

            return [start, 0.5 * (start + stop), stop]
        }

        switch (colorScaleType) {
            case colorScaleTypes.customOrange:
                range = ['#4A90E2', '#fff', '#ffa500']
                break
            case colorScaleTypes.threePointSavantColorScale:
                range = ['#3661ad', '#192c46', '#d82129']
                break
            case colorScaleTypes.blueWhiteRed:
                range = ['#4A90E2', '#fff', '#D0021B']
                break
            case colorScaleTypes.blueBlackRed:
                range = ['#4A90E2', '#000', '#D0021B']
                break
            case colorScaleTypes.blueGrayRed:
                range = ['#4A90E2', '#888', '#D0021B']
                break
            case colorScaleTypes.blueWhiteRedConstantSB:
                range = ['#0262D1', '#fff', '#D0021B']
                break
            case colorScaleTypes.blueWhiteRedConstantSB2:
                range = ['#2066AC', '#fcf7fc', '#B2182B']
                break
            case colorScaleTypes.blueWMagentaRedConstantSB:
                range = ['#4A90E2', '#e04ae0', '#e04a5e']
                break
            case colorScaleTypes.originalSavantColorScale:
            default:
                return toOriginalSavantColorScale(dataType, data)
        }

        return d3.scaleLinear().domain(domain).range(range).clamp(true)
    }

    const MakeChart = function (opts, callback) {
        const SHOW_REFERENCE = false
        // var SEGMENT_STROKE_COLOR = '#888';//'#666';
        // var SEGMENT_STROKE_WIDTH = 1;
        const ZONE_FRAME_COLOR = '#111111b3'
        // var ZONE_FRAME_STROKE_WIDTH = 5;
        const ZONE_FRAME_STROKE_OPACITY = 0.9

        function removeLeadingZero(value) {
            if (value && value.length > 0 && value.substring(0, 1) === '0') {
                return value.substring(1)
            }
            return value
        }

        function capitalize(str) {
            return str.replace(/^\w/, (chr) => chr.toUpperCase())
        }

        function toCornerType(segment) {
            const { id } = segment

            if (id === 21 || id === 31) {
                return 'upper-left'
            }
            if (id === 23 || id === 33) {
                return 'upper-right'
            }
            if (id === 27 || id === 37) {
                return 'lower-left'
            }
            if (id === 29 || id === 39) {
                return 'lower-right'
            }
        }

        function addTagPositions(segments) {
            segments.forEach((segment) => {
                if (segment.shape !== 'rect') {
                    const cornerType = toCornerType(segment)
                    pts = segment.points

                    switch (cornerType) {
                        case 'upper-left':
                            segment.tagX = pts[0] + 0.5 * (pts[6] - pts[0])
                            segment.tagY = pts[1] + 0.5 * (pts[5] - pts[1])
                            break
                        case 'upper-right':
                            segment.tagX = pts[2] - 0.5 * (pts[2] - pts[6])
                            segment.tagY = pts[1] + 0.5 * (pts[9] - pts[1])
                            break
                        case 'lower-left':
                            segment.tagX = pts[0] + 0.5 * (pts[2] - pts[0])
                            segment.tagY = pts[5] - 0.5 * (pts[5] - pts[9])
                            break
                        case 'lower-right':
                            segment.tagX = pts[0] + 0.5 * (pts[2] - pts[0])
                            segment.tagY = pts[9] - 0.5 * (pts[9] - pts[7])
                            break
                        default:
                    }
                } else {
                    segment.tagX = segment.x + 0.5 * segment.width
                    segment.tagY = segment.y + 0.5 * segment.height
                }
            })
        }

        function toDim(opts, showFooter, hasFooterText) {
            const zoneAspectRatio = 5 / 6

            const chartWidth = opts.width || 200
            const chartHeight = chartWidth / zoneAspectRatio
            // var plateFrameHeight = .1 * chartHeight;
            const plateFrameHeight = opts.plate ? 0.1 * chartHeight : 0
            let footerFrameHeight = showFooter ? 0.15 * chartHeight : 0

            if (hasFooterText) {
                footerFrameHeight += 0.11 * chartHeight
            }

            const footerFrameTop = chartHeight + plateFrameHeight
            const svgWidth = chartWidth
            const svgHeight = chartHeight + plateFrameHeight + footerFrameHeight

            const halfChartWidth = 0.5 * chartWidth
            const halfChartHeight = 0.5 * chartHeight

            const heartX = 6.7
            const innerHeartX = 0.5 * heartX
            const plateX = 8.5
            const zoneX = 10
            const shadowX = 13.3
            const chaseX = 19.9
            const wasteX = 26.5

            const heartY = 8
            const innerHeartY = 0.5 * heartY
            const zoneY = 12
            const shadowY = 16
            const chaseY = 24
            const wasteY = 32

            const normHeartX = heartX / wasteX
            const normInnerHeartX = innerHeartX / wasteX
            const normPlateX = plateX / wasteX
            const normZoneX = zoneX / wasteX
            const normShadowX = shadowX / wasteX
            const normChaseX = chaseX / wasteX
            const normWasteX = 1

            const normHeartY = heartY / wasteY
            const normInnerHeartY = innerHeartY / wasteY
            const normZoneY = zoneY / wasteY
            const normShadowY = shadowY / wasteY
            const normChaseY = chaseY / wasteY
            const normWasteY = 1

            const xCoreRight = normInnerHeartX * halfChartWidth
            const xHeartRight = normHeartX * halfChartWidth
            const xPlateRight = normPlateX * halfChartWidth
            const xZoneRight = normZoneX * halfChartWidth
            const xShadowRight = normShadowX * halfChartWidth
            const xChaseRight = normChaseX * halfChartWidth
            const xWasteRight = normWasteX * halfChartWidth

            const xCoreLeft = -xCoreRight
            const xHeartLeft = -xHeartRight
            const xPlateLeft = -xPlateRight
            const xZoneLeft = -xZoneRight
            const xShadowLeft = -xShadowRight
            const xChaseLeft = -xChaseRight
            const xWasteLeft = -xWasteRight

            // negate norm to convert to svg's left handed y coordinates
            const yWasteTop = -normWasteY * halfChartHeight
            const yChaseTop = -normChaseY * halfChartHeight
            const yShadowTop = -normShadowY * halfChartHeight
            const yZoneTop = -normZoneY * halfChartHeight
            const yHeartTop = -normHeartY * halfChartHeight
            const yCoreTop = -normInnerHeartY * halfChartHeight

            const yCoreBottom = -yCoreTop
            const yHeartBottom = -yHeartTop
            const yZoneBottom = -yZoneTop
            const yShadowBottom = -yShadowTop
            const yChaseBottom = -yChaseTop
            const yWasteBottom = -yWasteTop

            const dim = {
                svgWidth,
                svgHeight,
                chartWidth,
                chartHeight,
                chartOriginX: 0.5 * chartWidth,
                chartOriginY: 0.5 * chartHeight,
                plateFrameWidth: svgWidth,
                plateFrameHeight,
                footerWidth: svgWidth,
                footerFrameHeight,
                footerFrameTop,

                // zone segment coordinates
                xCoreRight,
                xHeartRight,
                xPlateRight,
                xZoneRight,
                xShadowRight,
                xChaseRight,
                xWasteRight,

                xCoreLeft,
                xHeartLeft,
                xPlateLeft,
                xZoneLeft,
                xShadowLeft,
                xChaseLeft,
                xWasteLeft,

                yWasteTop,
                yChaseTop,
                yShadowTop,
                yZoneTop,
                yHeartTop,
                yCoreTop,

                yCoreBottom,
                yHeartBottom,
                yZoneBottom,
                yShadowBottom,
                yChaseBottom,
                yWasteBottom,

                segments: {
                    1: {
                        id: 1,
                        region: 'heart',
                        corner: true,
                        shape: 'rect',
                        x: xHeartLeft,
                        y: yHeartTop,
                        width: xCoreLeft - xHeartLeft,
                        height: yCoreTop - yHeartTop,
                    },
                    2: {
                        id: 2,
                        region: 'heart',
                        corner: false,
                        shape: 'rect',
                        x: xCoreLeft,
                        y: yHeartTop,
                        width: xCoreRight - xCoreLeft,
                        height: yCoreTop - yHeartTop,
                    },
                    3: {
                        id: 3,
                        region: 'heart',
                        corner: true,
                        shape: 'rect',
                        x: xCoreRight,
                        y: yHeartTop,
                        width: xHeartRight - xCoreRight,
                        height: yCoreTop - yHeartTop,
                    },
                    4: {
                        id: 4,
                        region: 'heart',
                        corner: false,
                        shape: 'rect',
                        x: xHeartLeft,
                        y: yCoreTop,
                        width: xCoreLeft - xHeartLeft,
                        height: yCoreBottom - yCoreTop,
                    },
                    5: {
                        id: 5,
                        region: 'heart',
                        corner: false,
                        shape: 'rect',
                        x: xCoreLeft,
                        y: yCoreTop,
                        width: xCoreRight - xCoreLeft,
                        height: yCoreBottom - yCoreTop,
                    },
                    6: {
                        id: 6,
                        region: 'heart',
                        corner: false,
                        shape: 'rect',
                        x: xCoreRight,
                        y: yCoreTop,
                        width: xHeartRight - xCoreRight,
                        height: yCoreBottom - yCoreTop,
                    },
                    7: {
                        id: 7,
                        region: 'heart',
                        corner: true,
                        shape: 'rect',
                        x: xHeartLeft,
                        y: yCoreBottom,
                        width: xCoreLeft - xHeartLeft,
                        height: yHeartBottom - yCoreBottom,
                    },
                    8: {
                        id: 8,
                        region: 'heart',
                        corner: false,
                        shape: 'rect',
                        x: xCoreLeft,
                        y: yCoreBottom,
                        width: xCoreRight - xCoreLeft,
                        height: yHeartBottom - yCoreBottom,
                    },
                    9: {
                        id: 9,
                        region: 'heart',
                        corner: true,
                        shape: 'rect',
                        x: xCoreRight,
                        y: yCoreBottom,
                        width: xHeartRight - xCoreRight,
                        height: yHeartBottom - yCoreBottom,
                    },

                    // shadow
                    11: {
                        id: 11,
                        region: 'shadow',
                        corner: true,
                        shape: 'rect',
                        x: xShadowLeft,
                        y: yShadowTop,
                        width: xHeartLeft - xShadowLeft,
                        height: yHeartTop - yShadowTop,
                    },
                    12: {
                        id: 12,
                        region: 'shadow',
                        corner: false,
                        shape: 'rect',
                        x: xHeartLeft,
                        y: yShadowTop,
                        width: xHeartRight - xHeartLeft,
                        height: yHeartTop - yShadowTop,
                    },
                    13: {
                        id: 13,
                        region: 'shadow',
                        corner: true,
                        shape: 'rect',
                        x: xHeartRight,
                        y: yShadowTop,
                        width: xShadowRight - xHeartRight,
                        height: yHeartTop - yShadowTop,
                    },
                    14: {
                        id: 14,
                        region: 'shadow',
                        corner: false,
                        shape: 'rect',
                        x: xShadowLeft,
                        y: yHeartTop,
                        width: xHeartLeft - xShadowLeft,
                        height: yHeartBottom - yHeartTop,
                    },
                    16: {
                        id: 16,
                        region: 'shadow',
                        corner: false,
                        shape: 'rect',
                        x: xHeartRight,
                        y: yHeartTop,
                        width: xShadowRight - xHeartRight,
                        height: yHeartBottom - yHeartTop,
                    },
                    17: {
                        id: 17,
                        region: 'shadow',
                        corner: true,
                        shape: 'rect',
                        x: xShadowLeft,
                        y: yHeartBottom,
                        width: xHeartLeft - xShadowLeft,
                        height: yShadowBottom - yHeartBottom,
                    },
                    18: {
                        id: 18,
                        region: 'shadow',
                        corner: false,
                        shape: 'rect',
                        x: xHeartLeft,
                        y: yHeartBottom,
                        width: xHeartRight - xHeartLeft,
                        height: yShadowBottom - yHeartBottom,
                    },
                    19: {
                        id: 19,
                        region: 'shadow',
                        corner: true,
                        shape: 'rect',
                        x: xHeartRight,
                        y: yHeartBottom,
                        width: xShadowRight - xHeartRight,
                        height: yShadowBottom - yHeartBottom,
                    },

                    // chase
                    21: {
                        id: 21,
                        region: 'chase',
                        corner: true,
                        shape: 'polygon',
                        points: [
                            xChaseLeft,
                            yChaseTop,
                            xHeartLeft,
                            yChaseTop,
                            xHeartLeft,
                            yShadowTop,
                            xShadowLeft,
                            yShadowTop,
                            xShadowLeft,
                            yHeartTop,
                            xChaseLeft,
                            yHeartTop,
                        ],
                    },
                    22: {
                        id: 22,
                        region: 'chase',
                        corner: false,
                        shape: 'rect',
                        x: xHeartLeft,
                        y: yChaseTop,
                        width: xHeartRight - xHeartLeft,
                        height: yShadowTop - yChaseTop,
                    },
                    23: {
                        id: 23,
                        region: 'chase',
                        corner: true,
                        shape: 'polygon',
                        points: [
                            xHeartRight,
                            yChaseTop,
                            xChaseRight,
                            yChaseTop,
                            xChaseRight,
                            yHeartTop,
                            xShadowRight,
                            yHeartTop,
                            xShadowRight,
                            yShadowTop,
                            xHeartRight,
                            yShadowTop,
                        ],
                    },
                    24: {
                        id: 24,
                        region: 'chase',
                        corner: false,
                        shape: 'rect',
                        x: xChaseLeft,
                        y: yHeartTop,
                        width: xShadowLeft - xChaseLeft,
                        height: yHeartBottom - yHeartTop,
                    },
                    26: {
                        id: 26,
                        region: 'chase',
                        corner: false,
                        shape: 'rect',
                        x: xShadowRight,
                        y: yHeartTop,
                        width: xChaseRight - xShadowRight,
                        height: yHeartBottom - yHeartTop,
                    },
                    27: {
                        id: 27,
                        region: 'chase',
                        corner: true,
                        shape: 'polygon',
                        points: [
                            xChaseLeft,
                            yHeartBottom,
                            xShadowLeft,
                            yHeartBottom,
                            xShadowLeft,
                            yShadowBottom,
                            xHeartLeft,
                            yShadowBottom,
                            xHeartLeft,
                            yChaseBottom,
                            xChaseLeft,
                            yChaseBottom,
                        ],
                    },
                    28: {
                        id: 28,
                        region: 'chase',
                        corner: false,
                        shape: 'rect',
                        x: xHeartLeft,
                        y: yShadowBottom,
                        width: xHeartRight - xHeartLeft,
                        height: yChaseBottom - yShadowBottom,
                    },
                    29: {
                        id: 29,
                        region: 'chase',
                        corner: true,
                        shape: 'polygon',
                        points: [
                            xShadowRight,
                            yHeartBottom,
                            xChaseRight,
                            yHeartBottom,
                            xChaseRight,
                            yChaseBottom,
                            xHeartRight,
                            yChaseBottom,
                            xHeartRight,
                            yShadowBottom,
                            xShadowRight,
                            yShadowBottom,
                        ],
                    },

                    // waste
                    31: {
                        id: 31,
                        region: 'waste',
                        corner: true,
                        shape: 'polygon',
                        points: [
                            xWasteLeft,
                            yWasteTop,
                            xHeartLeft,
                            yWasteTop,
                            xHeartLeft,
                            yChaseTop,
                            xChaseLeft,
                            yChaseTop,
                            xChaseLeft,
                            yHeartTop,
                            xWasteLeft,
                            yHeartTop,
                        ],
                    },
                    32: {
                        id: 32,
                        region: 'waste',
                        corner: false,
                        shape: 'rect',
                        x: xHeartLeft,
                        y: yWasteTop,
                        width: xHeartRight - xHeartLeft,
                        height: yChaseTop - yWasteTop,
                    },
                    33: {
                        id: 33,
                        region: 'waste',
                        corner: true,
                        shape: 'polygon',
                        points: [
                            xHeartRight,
                            yWasteTop,
                            xWasteRight,
                            yWasteTop,
                            xWasteRight,
                            yHeartTop,
                            xChaseRight,
                            yHeartTop,
                            xChaseRight,
                            yChaseTop,
                            xHeartRight,
                            yChaseTop,
                        ],
                    },
                    34: {
                        id: 34,
                        region: 'waste',
                        corner: false,
                        shape: 'rect',
                        x: xWasteLeft,
                        y: yHeartTop,
                        width: xChaseLeft - xWasteLeft,
                        height: yHeartBottom - yHeartTop,
                    },
                    36: {
                        id: 36,
                        region: 'waste',
                        corner: false,
                        shape: 'rect',
                        x: xChaseRight,
                        y: yHeartTop,
                        width: xWasteRight - xChaseRight,
                        height: yHeartBottom - yHeartTop,
                    },
                    37: {
                        id: 37,
                        region: 'waste',
                        corner: true,
                        shape: 'polygon',
                        points: [
                            xWasteLeft,
                            yHeartBottom,
                            xChaseLeft,
                            yHeartBottom,
                            xChaseLeft,
                            yChaseBottom,
                            xHeartLeft,
                            yChaseBottom,
                            xHeartLeft,
                            yWasteBottom,
                            xWasteLeft,
                            yWasteBottom,
                        ],
                    },
                    38: {
                        id: 38,
                        region: 'waste',
                        corner: false,
                        shape: 'rect',
                        x: xHeartLeft,
                        y: yChaseBottom,
                        width: xHeartRight - xHeartLeft,
                        height: yWasteBottom - yChaseBottom,
                    },
                    39: {
                        id: 39,
                        region: 'waste',
                        corner: true,
                        shape: 'polygon',
                        points: [
                            xChaseRight,
                            yHeartBottom,
                            xWasteRight,
                            yHeartBottom,
                            xWasteRight,
                            yWasteBottom,
                            xHeartRight,
                            yWasteBottom,
                            xHeartRight,
                            yChaseBottom,
                            xChaseRight,
                            yChaseBottom,
                        ],
                    },
                },
            }

            addTagPositions(_.values(dim.segments))

            return dim
        }

        function toChartType(opts) {
            if (opts.chart_title) {
                return opts.chart_title
            }

            return dataTypeMap[opts.type] || 'Zones'
        }

        function toColor(d, type, scale) {
            const val = d[type]

            if (val === null || val === undefined) {
                // return 'none'
                // return '#888'
                return '#333'
            }

            let color = '#FFFFFF'

            if (type === 'ba' || type === 'baa') {
                color = scale(d.ba)
            } else if (
                type === 'pitches' ||
                type === 'hits' ||
                type === 'hr' ||
                type === 'k'
            ) {
                color = scale(d.pitches)
            } else if (type === 'iso') {
                color = scale(d.iso)
            } else if (type === 'slg') {
                color = scale(d.slg)
            } else if (type === 'babip') {
                color = scale(d.babip)
            } else if (type === 'pitch_percent') {
                let percent
                if (
                    d.pitches === undefined ||
                    d.total_pitches === undefined ||
                    d.total_pitches === 0
                ) {
                    percent = 0
                } else {
                    percent = (d.pitches / d.total_pitches) * 100
                }
                color = scale(percent)
            } else if (type === 'velocity') {
                color = scale(d.velocity)
            } else if (type === 'spin_rate') {
                color = scale(d.spin_rate)
            } else if (
                type === 'launch_speed' ||
                type === 'exit_velocity' ||
                type === 'exit_velocity_against'
            ) {
                color = scale(d.launch_speed)
            } else if (type === 'effective_speed') {
                color = scale(d.effective_speed)
            } else if (type === 'video') {
                if (d.video) {
                    color = '#FF0000'
                } else {
                    color = '#c2c2c2'
                }
            } else if (type === 'zScore') {
                color = scale(val)
            } else {
                color = '#c2c2c2'
            }

            if (color === '#NaNNaNNaN') {
                color = '#FFFFFF'
            }
            return color
        }

        function toOriginalSavantColorScale(dataType, data) {
            const colorPalette = [
                '#3661ad',
                '#3560aa',
                '#335da5',
                '#31589c',
                '#2e5391',
                '#294b83',
                '#254271',
                '#213a60',
                '#192c46',
                '#4a1d23',
                '#6d1b22',
                '#851e25',
                '#9c1d25',
                '#b01e26',
                '#c02028',
                '#cc2028',
                '#d42129',
                '#d82129',
            ]
            const scale = d3.scaleLinear().clamp(true)

            if (dataType === 'ba' || dataType === 'baa') {
                scale
                    .domain(d3.range(0, 0.5, 0.5 / (colorPalette.length - 1)))
                    .range(colorPalette)
            }
            if (dataType === 'iso') {
                scale
                    .domain(d3.range(0, 0.25, 0.25 / (colorPalette.length - 1)))
                    .range(colorPalette)
            }
            if (dataType === 'slg') {
                scale
                    .domain(d3.range(0, 1.25, 1 / (colorPalette.length - 1)))
                    .range(colorPalette)
            }
            if (dataType === 'babip') {
                scale
                    .domain(d3.range(0, 0.6, 0.6 / (colorPalette.length - 1)))
                    .range(colorPalette)
            }
            if (
                dataType === 'pitches' ||
                dataType === 'hits' ||
                dataType === 'hr' ||
                dataType === 'k'
            ) {
                scale
                    .domain(
                        d3.range(
                            0,
                            data[0].total_pitches,
                            data[0].total_pitches /
                                4 /
                                (colorPalette.length - 1)
                        )
                    )
                    .range(colorPalette)
            }
            if (dataType === 'pitch_percent') {
                scale
                    .domain(d3.range(0, 100, 25 / (colorPalette.length - 1)))
                    .range(colorPalette)
            }
            if (dataType === 'velocity') {
                scale.domain(d3.range(70, 100, 1.5)).range(colorPalette)
            }
            if (dataType === 'spin_rate') {
                scale
                    .domain(
                        d3.range(1500, 3000, 1500 / (colorPalette.length - 1))
                    )
                    .range(colorPalette)
            }
            if (
                dataType === 'launch_speed' ||
                dataType === 'exit_velocity' ||
                dataType === 'exit_velocity_against'
            ) {
                scale.domain(d3.range(80, 105, 1.4)).range(colorPalette)
            }
            if (dataType === 'effective_speed') {
                scale
                    .domain(d3.range(65, 100, 100 / (colorPalette.length - 1)))
                    .range(colorPalette)
            }

            return scale
        }

        function toOutermostRegion(regions) {
            if (regions.waste) {
                return 'waste'
            }
            if (regions.chase) {
                return 'chase'
            }
            if (regions.shadow) {
                return 'shadow'
            }
            if (regions.heart) {
                return 'heart'
            }

            return null
        }

        function toScale(outerRegion) {
            const heartX = 6.7
            const shadowX = 13.3
            const chaseX = 19.9
            const wasteX = 26.5

            switch (outerRegion) {
                case 'waste':
                default:
                    return 1
                case 'chase':
                    return wasteX / chaseX
                case 'shadow':
                    return wasteX / shadowX
                case 'heart':
                    return wasteX / heartX
            }
        }

        function adjustToFit(g, regions) {
            g.select('g.region.waste').style('opacity', regions.waste ? 1 : 0)
            g.select('g.region.chase').style('opacity', regions.chase ? 1 : 0)
            g.select('g.region.shadow').style('opacity', regions.shadow ? 1 : 0)
            g.select('g.region.heart').style('opacity', regions.heart ? 1 : 0)
        }

        function AttackZone(opts, callback) {
            opts = _.defaults(opts, {
                id: 'attack_zone',
                svgId: 'attack_zone',
                show_footer: 'true',
                type: 'ba',
                width: 200,
                height: 240,
                backgroundColor: '#ddd',
                segmentStokeWidth: 0.5,
                segmentStrokeColor: 'darken', // '#888',
                colorScaleType: colorScaleTypes.blueWhiteRed,
                regions: {
                    heart: true,
                    shadow: true,
                    chase: true,
                    waste: true,
                },
                valueTags: false,
                tooltips: true,
                plate: true,
                footerText: '',
                zone_data: {},
            })

            const sel = `#${opts.id}`
            let svg
            let heatmapColor
            let lineFunction
            let nameSize
            let height
            let width
            let scaleFontSize
            let scaleFontSizeSmall
            const showFooter =
                opts.show_footer === 'true' ||
                opts.show_footer === true ||
                opts.show_footer === undefined ||
                opts.show_footer === null
            const hasFooterText = opts.footerText && opts.footerText.length > 0
            const dim = toDim(opts, showFooter, hasFooterText)
            const outerRegion = toOutermostRegion(opts.regions)
            const scale = toScale(outerRegion)

            function initSvg(dim) {
                if (typeof window === 'undefined') {
                    // TODO    handle jsdom here?
                } else {
                    svg = d3
                        .select(sel)
                        .append('svg')
                        .attr('id', opts.svgId || `svg_${opts.id}`)
                        .attr('width', dim.svgWidth)
                        .attr('height', dim.svgHeight)

                    // // temporary place holders
                    //
                    // // zone
                    // svg.append('rect')
                    //     .attr('x', 0)
                    //     .attr('y', 0)
                    //     .attr('width', dim.chartWidth)
                    //     .attr('height', dim.chartHeight)
                    //     .style('fill', '#ffb8be');
                    //
                    // // plate frame
                    // svg.append('rect')
                    //     .attr('x', 0)
                    //     .attr('y', dim.chartHeight)
                    //     .attr('width', dim.plateFrameWidth)
                    //     .attr('height', dim.plateFrameHeight)
                    //     .style('fill', '#c4ffc4');
                    //
                    // // footer
                    // svg.append('rect')
                    //     .attr('x', 0)
                    //     .attr('y', dim.chartHeight + dim.plateFrameHeight)
                    //     .attr('width', dim.footerWidth)
                    //     .attr('height', dim.footerFrameHeight)
                    //     .style('fill', '#5395ff');
                }

                return svg
            }

            function calculateTotalPitches() {
                let total_pitches = 0
                for (let i = 0; i < opts.zone_data.length; i++) {
                    total_pitches += +opts.zone_data[i].pitches
                }
                for (let j = 0; j < opts.zone_data.length; j++) {
                    opts.zone_data[j].total_pitches = total_pitches
                }
            }

            function initScales() {
                lineFunction = d3
                    .line()
                    .x((d) => d.x)
                    .y((d) => d.y)

                nameSize = 0
                if (showFooter) {
                    height = opts.height - opts.height * 0.2
                    width = opts.width
                    // nameSize = (opts.height * .2);
                    nameSize = opts.height * 0.3
                } else {
                    height = opts.height
                    width = opts.width
                }

                scaleFontSize = d3.scaleLinear().domain([0, 500]).range([4, 22])

                scaleFontSizeSmall = d3
                    .scaleLinear()
                    .domain([0, 500])
                    .range([4, 18])
            }

            function toText(d, type) {
                const val = d[type]
                if (val === null || val === undefined) {
                    return 'NA'
                }

                switch (type) {
                    case 'ba':
                    case 'baa':
                    case 'iso':
                    case 'slg':
                    case 'babip':
                        return removeLeadingZero(val)
                    case 'pitches':
                    case 'hits':
                    case 'hr':
                    case 'k':
                        return d.pitches
                    case 'pitch_percent':
                        var percent =
                            d.pitches === undefined ||
                            d.total_pitches === undefined ||
                            d.total_pitches === 0
                                ? 0
                                : (d.pitches / d.total_pitches) * 100

                        return `${percent.toFixed(1)}%`
                    case 'velocity':
                    case 'spin_rate':
                    case 'effective_speed':
                        return val
                    case 'launch_speed':
                    case 'exit_velocity':
                    case 'exit_velocity_against':
                        return d.launch_speed
                    default:
                        return d.zone
                }
            }

            function appendBackground(svg, color) {
                color = color || '#fff'

                svg.append('rect')
                    .attr('height', '100%')
                    .attr('width', '100%')
                    .attr('fill', color)
            }

            function appendChartBack(g, dim) {
                svg.append('rect')
                    .attr('height', dim.chartHeight)
                    .attr('width', dim.chartWidth)
                    .attr('fill', '#333')
            }

            function appendReference(g, dim) {
                const gRef = g.append('g').classed('reference', true)

                // origin
                gRef.append('circle')
                    .attr('cx', 0)
                    .attr('cy', 0)
                    .attr('r', 3)
                    .style('fill', '#666')

                function line(x1, y1, x2, y2, classname, color) {
                    classname = classname || 'unknown'
                    color = color || '#0008'

                    gRef.append('line')
                        .classed(classname, true)
                        .attr('x1', x1)
                        .attr('y1', y1)
                        .attr('x2', x2)
                        .attr('y2', y2)
                        .style('stroke', color)
                        .style('stroke-width', 3)
                }

                line(
                    dim.xWasteLeft,
                    dim.yWasteTop,
                    dim.xWasteLeft,
                    dim.yWasteBottom,
                    'waste left',
                    '#f00'
                )
                line(
                    dim.xChaseLeft,
                    dim.yChaseTop,
                    dim.xChaseLeft,
                    dim.yChaseBottom,
                    'chase left',
                    '#0f0'
                )
                line(
                    dim.xShadowLeft,
                    dim.yShadowTop,
                    dim.xShadowLeft,
                    dim.yShadowBottom,
                    'shadow left',
                    '#00f'
                )
                line(
                    dim.xZoneLeft,
                    dim.yZoneTop,
                    dim.xZoneLeft,
                    dim.yZoneBottom,
                    'zone left',
                    '#ff0'
                )
                line(
                    dim.xHeartLeft,
                    dim.yHeartTop,
                    dim.xHeartLeft,
                    dim.yHeartBottom,
                    'heart left',
                    '#f0f'
                )
                line(
                    dim.xCoreLeft,
                    dim.yHeartTop,
                    dim.xCoreLeft,
                    dim.yHeartBottom,
                    'core heart left',
                    '#0ff'
                )

                line(
                    dim.xCoreRight,
                    dim.yHeartTop,
                    dim.xCoreRight,
                    dim.yHeartBottom,
                    'core heart right',
                    '#0ff'
                )
                line(
                    dim.xHeartRight,
                    dim.yHeartTop,
                    dim.xHeartRight,
                    dim.yHeartBottom,
                    'heart right',
                    '#f0f'
                )
                line(
                    dim.xZoneRight,
                    dim.yZoneTop,
                    dim.xZoneRight,
                    dim.yZoneBottom,
                    'zone right',
                    '#ff0'
                )
                line(
                    dim.xShadowRight,
                    dim.yShadowTop,
                    dim.xShadowRight,
                    dim.yShadowBottom,
                    'shadow right',
                    '#00f'
                )
                line(
                    dim.xChaseRight,
                    dim.yChaseTop,
                    dim.xChaseRight,
                    dim.yChaseBottom,
                    'chase right',
                    '#0f0'
                )
                line(
                    dim.xWasteRight,
                    dim.yWasteTop,
                    dim.xWasteRight,
                    dim.yWasteBottom,
                    'waste right',
                    '#f00'
                )

                line(
                    dim.xWasteLeft,
                    dim.yWasteTop,
                    dim.xWasteRight,
                    dim.yWasteTop,
                    'waste top',
                    '#f00'
                )
                line(
                    dim.xChaseLeft,
                    dim.yChaseTop,
                    dim.xChaseRight,
                    dim.yChaseTop,
                    'chase top',
                    '#0f0'
                )
                line(
                    dim.xShadowLeft,
                    dim.yShadowTop,
                    dim.xShadowRight,
                    dim.yShadowTop,
                    'shadow top',
                    '#00f'
                )
                line(
                    dim.xZoneLeft,
                    dim.yZoneTop,
                    dim.xZoneRight,
                    dim.yZoneTop,
                    'zone top',
                    '#ff0'
                )
                line(
                    dim.xHeartLeft,
                    dim.yHeartTop,
                    dim.xHeartRight,
                    dim.yHeartTop,
                    'heart top',
                    '#f0f'
                )
                line(
                    dim.xHeartLeft,
                    dim.yCoreTop,
                    dim.xHeartRight,
                    dim.yCoreTop,
                    'core top',
                    '#0ff'
                )

                line(
                    dim.xHeartLeft,
                    dim.yCoreBottom,
                    dim.xHeartRight,
                    dim.yCoreBottom,
                    'core bottom',
                    '#0ff'
                )
                line(
                    dim.xHeartLeft,
                    dim.yHeartBottom,
                    dim.xHeartRight,
                    dim.yHeartBottom,
                    'heart bottom',
                    '#f0f'
                )
                line(
                    dim.xZoneLeft,
                    dim.yZoneBottom,
                    dim.xZoneRight,
                    dim.yZoneBottom,
                    'zone bottom',
                    '#ff0'
                )
                line(
                    dim.xShadowLeft,
                    dim.yShadowBottom,
                    dim.xShadowRight,
                    dim.yShadowBottom,
                    'shadow bottom',
                    '#00f'
                )
                line(
                    dim.xChaseLeft,
                    dim.yChaseBottom,
                    dim.xChaseRight,
                    dim.yChaseBottom,
                    'chase bottom',
                    '#0f0'
                )
                line(
                    dim.xWasteLeft,
                    dim.yWasteBottom,
                    dim.xWasteRight,
                    dim.yWasteBottom,
                    'waste bottom',
                    '#f00'
                )
            }

            function appendSegment(
                gChart,
                g,
                dim,
                segment,
                d,
                type,
                segmentStrokeWidth,
                segmentStrokeColor,
                valueTags,
                tooltips
            ) {
                const color = toColor(d, type, heatmapColor)
                const hsl = d3.hsl(color)
                const isDark = hsl.l < 0.4
                const textColor = isDark ? '#fff' : '#000'
                let segmentEl
                let strokeColor
                let c
                const gSegment = g
                    .append('g')
                    .attr('class', 'segment')
                    .attr('data-segment-id', segment.id)

                switch (segmentStrokeColor) {
                    case 'brighten':
                        c = d3.color(color)
                        strokeColor = c.brighter().toString()
                        break
                    case 'darken':
                        c = d3.color(color)
                        strokeColor = c.darker().toString()
                        break
                    default:
                        strokeColor = segmentStrokeColor
                }

                if (segment.shape === 'rect') {
                    segmentEl = gSegment
                        .append('rect')
                        .datum(d)
                        .classed(
                            `${segment.region} segmentZone_${segment.id}`,
                            true
                        )
                        .attr('x', segment.x)
                        .attr('y', segment.y)
                        .attr('width', segment.width)
                        .attr('height', segment.height)
                        .style('fill', color)
                        // .style('stroke', SEGMENT_STROKE_COLOR)
                        .style('stroke', strokeColor)
                        // .style('stroke-width', SEGMENT_STROKE_WIDTH);
                        .style('stroke-width', segmentStrokeWidth)
                } else if (segment.shape === 'polygon') {
                    segmentEl = gSegment
                        .append('polygon')
                        .datum(segment)
                        .classed(segment.region, true)
                        .attr('points', segment.points.join(' '))
                        .style('fill', color)
                        // .style('stroke', SEGMENT_STROKE_COLOR)
                        .style('stroke', strokeColor)
                        // .style('stroke-width', SEGMENT_STROKE_WIDTH);
                        .style('stroke-width', segmentStrokeWidth)
                }

                const fontSize = scaleFontSize(dim.svgWidth)
                const dy = 0.4 * fontSize
                const value = d[type]
                const formatted = toText(d, type)

                if (valueTags && value !== null && formatted !== 'NA') {
                    gSegment
                        .append('text')
                        // .text(segment.id)
                        //     .text(value)
                        .text(formatted)
                        .attr('x', segment.tagX)
                        .attr('y', segment.tagY + dy)
                        .style('fill', textColor)
                        // .style('fill', '#fff')
                        // .style('stroke', '#000000')
                        // .style('stroke-width', .5)
                        .style('font-size', fontSize)
                        .style('text-anchor', 'middle')
                        .style('user-select', 'none')
                }

                if (tooltips) {
                    // var val = toText(d, type);
                    // var titleText = capitalize(segment.region) + ', Segment ' + segment.id + ', ' + dataTypeMap[type] + ': ' + val;
                    //
                    // segmentEl.append('title')
                    //     .text(titleText);

                    gSegment
                        .on('mouseenter', function () {
                            beginHover(gChart, this, d, type, segment)
                        })
                        .on('mousemove', onMouseMove)
                        .on('mouseleave', () => {
                            endHover(gChart)
                        })
                }
            }

            function beginHover(gChart, el, d, type, segment) {
                const val = toText(d, type)
                const html =
                    `<b>${capitalize(segment.region)}</b><br/>` +
                    `Segment <b>${segment.id}</b><br/>${dataTypeMap[type]}: <b>${val}</b>`

                // set low opacity on all segments
                gChart.selectAll('g.segment').style('opacity', 0.05)

                // set mid opacity on segments in same region as this segment segment
                d3.select(el.parentElement)
                    .selectAll('g.segment')
                    .style('opacity', 0.3)

                // set this segment opaque
                gChart
                    .selectAll(`g.segment[data-segment-id="${segment.id}"]`)
                    .style('opacity', 1)

                d3.select('body')
                    .append('div')
                    .attr('class', 'attack-zone-tooltip')
                    .html(html)
                    .style('position', 'absolute')
                    .style('left', `${d3.event.pageX + 10}px`)
                    .style('top', `${d3.event.pageY + 10}px`)
                    .style('padding', '.5em')
                    .style('background-color', '#fff')
                    .style('border', 'solid black thin')
                    .style('border-radius', '.5em')
                    .style('opacity', 0)
                    .style('line-height', '1.5em')
                    .style('font-size', '.8rem')
                    .transition()
                    .duration(200)
                    .style('opacity', 0.9)
            }

            function onMouseMove() {
                d3.select('body div.attack-zone-tooltip')
                    .style('left', `${d3.event.pageX + 10}px`)
                    .style('top', `${d3.event.pageY + 10}px`)
            }

            function endHover(gChart) {
                gChart.selectAll('g.segment').style('opacity', 1)

                d3.select('body div.attack-zone-tooltip').remove()
            }

            function appendSegments(
                gChart,
                g,
                dim,
                ids,
                data,
                type,
                segmentStrokeWidth,
                segmentStrokeColor,
                valueTags,
                tooltips
            ) {
                const segments = ids.map((id) => dim.segments[id])

                segments.forEach((segment) => {
                    const d = data[segment.id]

                    appendSegment(
                        gChart,
                        g,
                        dim,
                        segment,
                        d,
                        type,
                        segmentStrokeWidth,
                        segmentStrokeColor,
                        valueTags,
                        tooltips
                    )
                })
            }

            function appendLabels(g, dim, ids, data) {
                const segments = ids.map((id) => dim.segments[id])

                segments.forEach((segment) => {
                    const d = data[segment.id]
                    const value = d[opts.type]
                    const x = 99
                    const y = 99
                    const text = toText(value, opts.type)

                    g.append('text')
                        .classed('label', true)
                        .attr('x', x)
                        .attr('y', y)
                        .text(text)
                        .style('fill', '#fff')
                })
            }

            function appendRegion(
                gChart,
                dim,
                data,
                type,
                segmentStrokeWidth,
                segmentStrokeColor,
                valueTags,
                tooltips,
                classname,
                segmentIds
            ) {
                const gRegion = gChart.append('g').classed(classname, true)

                appendSegments(
                    gChart,
                    gRegion,
                    dim,
                    segmentIds,
                    data,
                    type,
                    segmentStrokeWidth,
                    segmentStrokeColor,
                    valueTags,
                    tooltips
                )
            }

            function appendZoneFrame(g, dim, zoneThickness, zoneDash, zoneId) {
                const gZone = g.append('g').classed('zone', true)
                if (zoneId) {
                    gZone.attr('id', `zone_${zoneId}`)
                }
                const strokeWidth = zoneThickness || (dim.chartWidth / 40)
                const dashSpaceStr = zoneDash || `0,${dim.chartWidth / 21}`

                gZone
                    .append('rect')
                    .classed('zone', true)
                    .attr('x', dim.xZoneLeft)
                    .attr('y', dim.yZoneTop)
                    .attr('width', dim.xZoneRight - dim.xZoneLeft)
                    .attr('height', dim.yZoneBottom - dim.yZoneTop)
                    .style('fill', 'none')
                    .style('stroke', ZONE_FRAME_COLOR)
                    .style('stroke-opacity', ZONE_FRAME_STROKE_OPACITY)
                    // .style('stroke-width', ZONE_FRAME_STROKE_WIDTH)
                    .style('stroke-width', strokeWidth)
                    // .style('stroke-dasharray', '0,11')
                    .style('stroke-dasharray', dashSpaceStr)
                    .style('stroke-linecap', 'round')
            }

            function appendPlate(svg, dim) {
                const w = dim.plateFrameWidth
                const h = dim.plateFrameHeight
                const tipY = 0.8 * h
                const dy = 0.2 * h
                const coords = [
                    0,
                    0.0,
                    1.1 * dim.xZoneRight,
                    -dy,
                    0.9 * dim.xZoneRight,
                    -2 * dy,
                    0.9 * dim.xZoneLeft,
                    -2 * dy,
                    1.1 * dim.xZoneLeft,
                    -dy,
                ]

                svg.append('g')
                    .classed('plate', true)
                    .attr(
                        'transform',
                        `translate(${0.5 * w} ${dim.chartHeight + tipY})`
                    )
                    .append('polygon')
                    .attr('points', coords.join(' '))
                    .style('fill', '#fff')
                    .style('stroke', '#333')
            }

            function appendFooter(g, dim, data, freeText) {
                const gFooter = g
                    .append('g')
                    .classed('footer', true)
                    .attr(
                        'transform',
                        `translate(${0.5 * dim.svgWidth} ${dim.footerFrameTop})`
                    )
                const hasFreeText = freeText && freeText.length > 0
                const playerName = data[1].player_name
                const yName = hasFreeText
                    ? 0.25 * dim.footerFrameHeight
                    : 0.33 * dim.footerFrameHeight
                const chartType = toChartType(opts)
                const yType = hasFreeText
                    ? 0.5 * dim.footerFrameHeight
                    : 0.67 * dim.footerFrameHeight
                const yFreeText = 0.8 * dim.footerFrameHeight

                function appendFooterText(text, y, bold) {
                    gFooter
                        .append('text')
                        .attr('x', 0)
                        .attr('y', y)
                        .text(text)
                        .style('text-anchor', 'middle')
                        .style('font-size', scaleFontSize(dim.svgWidth))
                        .style('font-family', 'Roboto Condensed')
                        .style('font-weight', bold ? 'bolder' : 'normal')
                        .style('fill', '#000')
                        .style('stroke-width', 1)
                }

                appendFooterText(playerName, yName, true)
                appendFooterText(chartType, yType)

                hasFreeText && appendFooterText(freeText, yFreeText)
            }

            function drawChart(svg, dim, data, opts) {
                appendBackground(svg, opts.backgroundColor)

                appendChartBack(svg, dim)

                const {
                    type,
                    valueTags,
                    tooltips,
                    segmentStrokeWidth,
                    segmentStrokeColor,
                    zoneThickness = null,
                    zoneDash = null,
                    zoneId = null
                } = opts

                const gChart = svg
                    .append('g')
                    .classed('chart', true)
                    .attr(
                        'transform',
                        `translate(${dim.chartOriginX} ${dim.chartOriginY}) scale(${scale})`
                    )

                if (opts.zoneId) {
                    gChart.attr('id', `zone_chart_${zoneId}`)
                }

                if (SHOW_REFERENCE) {
                    appendReference(gChart, dim)
                }

                appendRegion(
                    gChart,
                    dim,
                    data,
                    type,
                    segmentStrokeWidth,
                    segmentStrokeColor,
                    valueTags,
                    tooltips,
                    'region waste',
                    [31, 32, 33, 34, 36, 37, 38, 39]
                )
                appendRegion(
                    gChart,
                    dim,
                    data,
                    type,
                    segmentStrokeWidth,
                    segmentStrokeColor,
                    valueTags,
                    tooltips,
                    'region chase',
                    [21, 22, 23, 24, 26, 27, 28, 29]
                )
                appendRegion(
                    gChart,
                    dim,
                    data,
                    type,
                    segmentStrokeWidth,
                    segmentStrokeColor,
                    valueTags,
                    tooltips,
                    'region shadow',
                    [11, 12, 13, 14, 16, 17, 18, 19]
                )
                appendRegion(
                    gChart,
                    dim,
                    data,
                    type,
                    segmentStrokeWidth,
                    segmentStrokeColor,
                    valueTags,
                    tooltips,
                    'region heart',
                    [1, 2, 3, 4, 5, 6, 7, 8, 9]
                )

                appendZoneFrame(gChart, dim, zoneThickness, zoneDash, zoneId)
                // appendPlate(svg, dim);
                if (opts.plate) {
                    appendPlate(svg, dim)
                }

                if (showFooter) {
                    appendFooter(svg, dim, data, opts.footerText)
                }

                adjustToFit(gChart, opts.regions)
            }

            const data = _.indexBy(opts.zone_data, 'api_gameday3_pitchzone_cd')

            calculateTotalPitches()

            initScales()
            heatmapColor = toColorScale(
                opts.colorScaleType,
                opts.type,
                opts.zone_data,
                opts.customHighlight,
            )

            svg = initSvg(dim)
            drawChart(svg, dim, data, opts)

            callback && callback(svg)
        }

        if (callback) {
            new AttackZone(opts, (svg) => {
                callback(svg)
            })
        } else {
            new AttackZone(opts)
        }
    }

    MakeChart.dataTypes = _.keys(dataTypeMap)
    MakeChart.colorScaleTypes = colorScaleTypes
    MakeChart.toColorScale = toColorScale

    if (typeof exports !== 'undefined') {
        if (typeof module !== 'undefined' && module.exports) {
            exports = module.exports = MakeChart
        }
        exports.MakeChart = MakeChart
    }

    if (typeof define === 'function' && define.amd) {
        define([], () => MakeChart)
    }
}.call(this))
